import { render } from "./MenuBar.vue?vue&type=template&id=007d7631&scoped=true"
import script from "./MenuBar.vue?vue&type=script&lang=js"
export * from "./MenuBar.vue?vue&type=script&lang=js"

import "./MenuBar.vue?vue&type=style&index=0&id=007d7631&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-007d7631"

export default script